module.exports = __webpack_public_path__ + "static/media/leamington-spencer-yard.1a562d64.jpg";